import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

import draftLogo from "@/assets/images/draftLogo.png";
import PDFPortrait from "@/components/Common/PDFs/PDFPortrait";
import PDFHeaderGlobo from "@/pages/Globo/Components/PDFHeaderGlobo";

const styles = StyleSheet.create({
  page: {
    position: "relative",
  },
  watermark: {
    position: "absolute",
    top: "-20%",
    left: "-5%",
    width: 600,
    opacity: 0.3,
    zIndex: -1,
  },
  title: {
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 14,
    marginBottom: 12,
  },
  dateSection: {
    fontSize: 9.5,
    marginBottom: 8,
  },
  greeting: {
    fontSize: 9.5,
    marginBottom: 6,
  },
  paragraph: {
    fontSize: 9.5,
    marginBottom: 0,
    lineHeight: 1.3,
  },
  bold: {
    fontWeight: "bold",
  },
  boldUnderline: {
    fontWeight: "bold",
    textDecoration: "underline",
  },
  tableTitle: {
    fontSize: 9.5,
    fontWeight: "bold",
    backgroundColor: "#2E75B6",
    color: "#FFFFFF",
    padding: 4,
    marginTop: 10,
    marginBottom: 0,
  },
  table: {
    width: "100%",
    borderLeft: "0.5pt solid #2E75B6",
    borderRight: "0.5pt solid #2E75B6",
    borderBottom: "0.5pt solid #2E75B6",
  },
  tableRow: {
    flexDirection: "row",
    borderTop: "0.5pt solid #2E75B6",
  },
  tableRowStripe: {
    backgroundColor: "#EBF3FA",
  },
  tableCell: {
    fontSize: 9,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 5,
    paddingRight: 5,
    borderRight: "0.5pt solid #2E75B6",
  },
  tableCellLeft: {
    width: "30%",
  },
  tableCellRight: {
    width: "70%",
  },
  tableCellRightBold: {
    width: "70%",
    fontWeight: "bold",
  },
  tableCellLast: {
    borderRight: "none",
  },
  footerText: {
    fontSize: 9.5,
    marginTop: 10,
    marginBottom: 0,
    lineHeight: 1.4,
    textAlign: "justify",
  },
  signatureLine: {
    fontSize: 9.5,
    marginBottom: 10,
  },
  signatureLineFirst: {
    marginTop: 42,
  },
  noteText: {
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 14,
  },
});

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const formatShortDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const year = date.getFullYear();
  return `(${day}-${month}-${year})`;
};

const LoaPDF = ({ pdfTitle, data }) => {
  return (
    <PDFPortrait pdfTitle={pdfTitle} Header={PDFHeaderGlobo} Footer={() => null}>
      <View style={styles.page}>
        {data?.statusName !== "Approved" && <Image src={draftLogo} style={styles.watermark} fixed />}

        <Text style={styles.title}>Letter of Authorization</Text>

        <Text style={styles.dateSection}>Date:{"    "}{formatDate(data?.dateSubmitted || data?.createdDate)}</Text>

        <Text style={styles.greeting}>
          {"Dear Healthcare Partner: "}
          <Text style={styles.boldUnderline}>{data?.purchasingAccountName || "—"}</Text>
        </Text>

        <Text style={styles.paragraph}>
          {"Kindly dispense "}
          <Text style={styles.bold}>{data?.productName}</Text>
          {" to the following patient as indicated below:"}
        </Text>

        <Text style={styles.tableTitle}>Patient Information</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableRowStripe]}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Name</Text>
            <Text style={[styles.tableCell, styles.tableCellRightBold, styles.tableCellLast]}>{data?.patientName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Patient Code</Text>
            <Text style={[styles.tableCell, styles.tableCellRightBold, styles.tableCellLast]}>{data?.patientCode}</Text>
          </View>
          <View style={[styles.tableRow, styles.tableRowStripe]}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Hospital</Text>
            <Text style={[styles.tableCell, styles.tableCellRightBold, styles.tableCellLast]}>{data?.hospitalName || "—"}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Physician</Text>
            <Text style={[styles.tableCell, styles.tableCellRightBold, styles.tableCellLast]}>{data?.doctorName}</Text>
          </View>
        </View>

        <Text style={styles.tableTitle}>Program Access Scheme</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableRowStripe]}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>LOA No.</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.referenceNo}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Product Item/s</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.productName}</Text>
          </View>
          <View style={[styles.tableRow, styles.tableRowStripe]}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Scheme</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.papSchemeName || "—"}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Commercial Reference</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>{data?.orderNo || "—"}</Text>
          </View>
          <View style={[styles.tableRow, styles.tableRowStripe]}>
            <Text style={[styles.tableCell, styles.tableCellLeft]}>Total Quantity</Text>
            <Text style={[styles.tableCell, styles.tableCellRight, styles.tableCellLast]}>
              {data?.quantity} {data?.uom}
            </Text>
          </View>
        </View>

        <Text style={styles.footerText}>
          <Text style={styles.bold}>{"Instructions: Important note to subdistributor: "}</Text>
          {"Please release the quantity of FOC/s reflected above. This LOA is valid "}
          <Text style={styles.bold}>15 days</Text>
          {" from date of release. This LOA is unique per patient. Only patients enrolled in the program are entitled to receive the free goods."}
        </Text>

        <Text style={[styles.signatureLine, styles.signatureLineFirst]}>
          {"Requested by: "}
          <Text style={styles.bold}>{data?.submittedByName}</Text>
          {"  "}{formatShortDate(data?.dateSubmitted)}
        </Text>

        <Text style={styles.signatureLine}>
          {"Approved by: "}
          <Text style={styles.bold}>{data?.approvedByName || "___________________"}</Text>
          {"  "}{data?.dateApproved ? formatShortDate(data?.dateApproved) : "(dd-mmm-yyyy)"}
        </Text>

        <Text style={styles.noteText}>
          {"Note: This is an electronically generated Letter of Availment and does not require a signature."}
        </Text>
      </View>
    </PDFPortrait>
  );
};

export default React.memo(LoaPDF);
